import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useMember } from '../../hooks/useMember';
import {
  functionsFor,
  mobileTabsFor,
  operationsFor,
  type FunctionId,
  type MobileTabId,
  type OperationId,
} from '../../lib/driverAppTabs';

/**
 * A tab's screen, or a Functions or Operations item's, for a member whose
 * role shows it; anyone else is sent Home rather than shown a list the
 * server would refuse. An item's screen opens wherever the item shows: from
 * its tab for the office, or as a tab of its own for someone who only
 * drives. Waits for the permissions first, so a link to /invoices is not
 * bounced while they load.
 */
export function RequireTab({
  tab,
  item,
  children,
}: {
  /** The tab, or for an item the tab that lists it. */
  tab: MobileTabId;
  /** The tab's item the screen is, when it is one: /invoices, /drivers. */
  item?: FunctionId | OperationId;
  children: React.ReactNode;
}) {
  const member = useMember();
  if (member.isLoading) return null;
  const items: ReadonlyArray<{ id: string }> =
    tab === 'operations' ? operationsFor(member) : functionsFor(member);
  const shown = item
    ? items.some((allowed) => allowed.id === item)
    : mobileTabsFor(member).includes(tab);
  if (!shown) return <Navigate to="/" replace />;
  return <>{children}</>;
}
